import React from "react";

const PowerBiDashboard = () => {
  return (
    <>
      <div className="d-flex justify-content-center h-100 w-100">
        <iframe
          src="https://app.powerbi.com/reportEmbed?reportId=64fd0523-5af2-407e-9ae7-14910a337c1f&autoAuth=true&ctid=7433e884-416d-49a2-81a4-5cedf12536e6"
          style={{ width: "100vw", height: "90vh" }}
        ></iframe>
      </div>
    </>
  );
};

export default PowerBiDashboard;
